import { cn } from '@ludus/ui'

interface FunnelPillProps {
  /** Two-letter abbreviation rendered in the pill (e.g. "GA" for Google Ads). */
  abbr: string
  /** Full channel label, used for tooltip + a11y. */
  label: string
  className?: string
}

/**
 * Neutral two-letter pill used to mark a deal's funnel/source channel in the deals
 * table and the SidePanel breakdown. Channels share one neutral tone — the abbreviation
 * carries identity, not the colour.
 */
export function FunnelPill({ abbr, label, className }: FunnelPillProps) {
  return (
    <span
      className={cn(
        'inline-flex h-5 min-w-[1.75rem] items-center justify-center rounded-sm border border-border/40 bg-background-secondary/80 px-1.5 text-[10px] font-semibold tracking-wide text-foreground',
        className,
      )}
      title={label}
      aria-label={label}
    >
      {abbr}
    </span>
  )
}
